import { StyledCard } from "./StyledCard";

// Decide height, width, color, border
export const Card = ({ type = "", onClick,  children }) => {
  return <StyledCard onClick={onClick} type={type}>{children}</StyledCard>;

};
